import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as TimelineService from "_services/timeline-service";
import { getDurationInMinutes, getSurveyStatus } from "_utils/functions";
// functions 
import { searchEmployeeName, searchEmployeeID } from "_utils/functions";

function firestoreTimestampToReadable(date) {



  const dateInGST = new Date(date.toISOString());
  const options = {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };
  const formattedDate = dateInGST.toLocaleString("en-US", options);

  return formattedDate;
}

const initialState = {
  employeeList: [],
  employeeFilter: "online",
  status: "idle",
  error: null,

  employeeSearch: '',
  employeeSearchFilter: "name",

  // add employee form
  employeeForm: {},
  addEmployeeStatus: "idle",
  addEmployeeError: null,
  addedEmployee: null,

  // edit password form
  passwordForm: {},
  editPasswordStatus: "idle",
  editPasswordError: null,
  editPassword: null,

  // employee information
  selectedEmployee: null,
  employeeTaskList: [],
  employeeTaskListStatus: "idle",
  employeeTaskListError: null,

  // delete employee flags
  deleteEmployeeStatus: "idle", // status loading flag for delete employee
  deleteEmployeeError: null,

  //update employee
  updateEmployeeStatus: "idle",
  updatedEmployeeProfile: null,
  updateEmployeeProfileError: null,


  // check user
  checkUserResult: null,
  checkUserStatus: "idle",
  checkUserError: null,

  //employee task notifications
  employeeTaskNotifications: null,
  employeeTaskNotificationsStatus: "idle",
  employeeTaskNotificationsError: null,

  //employee productivity
  employeeProductivity: null,
  employeeProductivityStatus: "idle",
  employeeProductivityError: null,



  //all tasks with filter
  allTaskListWithFilter: [],
  allTaskWithFilterStatus: "idle",
  allTaskWithFilterError: null,

  //assign employees workzone flags
  assignEmployeesWorkZoneStatus: "idle",
  assignEmployeesWorkZoneError: null,

  //remove workzone employees flags
  removeWorkzoneEmployeesStatus: "idle",
  removeWorkzoneEmployeesError: null,

  // employee Android app version
  androidAppVersion: null,
  androidAppVersionStatus: "idle",
  androidAppVersionError: null,

  totalEmpTasks: 0,

  selectedEmployeeProfile: null,

  employeeConversations: [],
  selectedForChat: null,
  employeeMessages: [],

  newDispatcherMessages: [],
  sendDispatcherMessageStatus: "idle",
  sendDispatcherMessageError: null,

  sendBroadcastMessageStatus: "idle",
  sendBroadcastMessageError: null,

  openBroadcastMessages: false,

  clickedEmployeeId: null,//this wil store userId of clicked employee, we save employeeId, which is not valid to patch enployee document

};

const EMPLOYEE_STATUS_FILTERS = ["online", "offline", "busy", "available", "onBreak"];

const employeeRolePriority = {
  manager: 1,
  supervisor: 1,
  allocator: 2,
  driver: 3,
  cca: 4,
  boarding: 5,
  marshaller: 6,
  desk: 7,
};

const employeeStatusPriority = {
  busy: 1,
  available: 2,
  online: 3,
  onBreak: 4,
  offline: 5,
};

const normaliseEmployeeStatus = (status) => (
  typeof status === "string" ? status.trim() : ""
);

const employeeHasSelectedTimeline = (employee, selectedId) => {
  const workZone = employee?.workZone;

  if (Array.isArray(workZone)) {
    return workZone.some((zone) => zone?._id === selectedId || zone?.id === selectedId);
  }

  if (workZone && typeof workZone === "object") {
    return workZone?._id === selectedId || workZone?.id === selectedId;
  }

  return false;
};

const getEmployeeEffectiveStatus = (employee, activeEmployeeIds, activeBreakEmployeeIds) => {
  const status = normaliseEmployeeStatus(employee?.status);
  const employeeId = employee?.employeeId;

  if (status === "offline") return "offline";
  if (status === "onBreak" || activeBreakEmployeeIds?.has(employeeId)) return "onBreak";
  if (status === "busy" || activeEmployeeIds?.has(employeeId)) return "busy";
  if (status === "available") return "available";

  return status === "online" ? "available" : status || "offline";
};

const filterEmployeeByStatus = (employee, filter, activeEmployeeIds, activeBreakEmployeeIds) => {
  if (filter === "all" || filter === "manual Search") return true;

  const effectiveStatus = getEmployeeEffectiveStatus(employee, activeEmployeeIds, activeBreakEmployeeIds);

  if (filter === "online") {
    return effectiveStatus !== "offline";
  }

  if (EMPLOYEE_STATUS_FILTERS.includes(filter)) {
    return effectiveStatus === filter;
  }

  return true;
};

const sortEmployeesByPresenceAndRole = (employees, activeEmployeeIds, activeBreakEmployeeIds) => {
  return [...(employees || [])].sort((a, b) => {
    const statusA = getEmployeeEffectiveStatus(a, activeEmployeeIds, activeBreakEmployeeIds);
    const statusB = getEmployeeEffectiveStatus(b, activeEmployeeIds, activeBreakEmployeeIds);

    if (statusA === "offline" && statusB !== "offline") return 1;
    if (statusA !== "offline" && statusB === "offline") return -1;

    const rolePriorityA = employeeRolePriority[a?.role?.toLowerCase()] || 99;
    const rolePriorityB = employeeRolePriority[b?.role?.toLowerCase()] || 99;

    if (rolePriorityA !== rolePriorityB) return rolePriorityA - rolePriorityB;

    const statusPriorityA = employeeStatusPriority[statusA] || 99;
    const statusPriorityB = employeeStatusPriority[statusB] || 99;

    if (statusPriorityA !== statusPriorityB) return statusPriorityA - statusPriorityB;

    const titleA = (a?.title || "").toString();
    const titleB = (b?.title || "").toString();

    return titleA.localeCompare(titleB);
  });
};

export const getEmployeeList = createAsyncThunk(
  "employees/getEmployeeList",
  async (iata) => {
    const result = await TimelineService.getEmployeeList(iata);
    return result;
  }
);

export const addEmployee = createAsyncThunk(
  "employees/addEmployee",
  async (details) => {
    console.log("[CreateEmployee] redux addEmployee thunk start", {
      title: details?.title,
      email: details?.email,
      role: details?.role,
      airport: details?.airport,
      status: details?.status,
      approved: details?.approved,
    });
    try {
      const result = await TimelineService.addEmployee(details);
      console.log("[CreateEmployee] redux addEmployee thunk success", {
        userId: result?.userId || result?.employeeId,
        email: result?.email,
        airport: result?.airport,
      });
      return result;
    } catch (error) {
      console.error("[CreateEmployee] redux addEmployee thunk failed", error?.message || error);
      throw error;
    }
  }
);

export const getEmployeeTasks = createAsyncThunk(
  "employees/getEmployeeTasks",
  async (employeeId) => {
    return TimelineService.getEmployeeTasks(employeeId);
  }
);

export const sendEmployeeNotification = createAsyncThunk(
  "employees/sendEmployeeNotification",
  async (details) => {
    return TimelineService.sendEmployeeNotification(details);
  }
);

// function for updating user firestore account information
export const updateEmployee = createAsyncThunk(
  "employees/updateEmployee",
  async (employee) => {
    return TimelineService.updateEmployee(employee);
  }
);

// function for deleting user firestore account information
export const deleteEmployee = createAsyncThunk(
  "employees/deleteEmployee",
  async (employee) => {
    return TimelineService.deleteEmployee(employee);
  }
);


export const checkUser = createAsyncThunk(
  "employees/checkUser",
  async (params) => {
    console.log("[CreateEmployee] redux checkUser thunk start", params);
    try {
      const result = await TimelineService.checkUser(params);
      console.log("[CreateEmployee] redux checkUser thunk success", result);
      return result;
    } catch (error) {
      console.error("[CreateEmployee] redux checkUser thunk failed", error?.message || error);
      throw error;
    }
  }
);

export const getEmployeeProductivity = createAsyncThunk(
  "employees/getEmployeeProductivity",
  async (props) => {
    return TimelineService.getEmployeeProductivity(props);
  }
);

export const getAllTaskListWithFilter = createAsyncThunk(
  "employees/getAllTaskListWithFilter",
  async (props) => {
    return TimelineService.getAllTaskListWithFilter(props);
  }
);
export const assignEmployeesWorkZone = createAsyncThunk(
  "employees/assignEmployeesWorkZone",
  async (props) => {
    return TimelineService.assignEmployeesWorkZone(props);
  }
);
export const removeWorkzoneEmployees = createAsyncThunk(
  "employees/removeWorkzoneEmployees",
  async (props) => {
    return TimelineService.assignEmployeesWorkZone(props);
  }
);
export const getAndroidAppVersion = createAsyncThunk(
  "employees/getAndroidAppVersion",
  async (iata) => {
    return TimelineService.getAndroidAppVersion(iata);
  }
);


export const updateOldEmployeeProfile = createAsyncThunk(
  "employees/updateOldEmployeeProfile",
  async (props) => {
    return TimelineService.updateOldEmployeeProfile(props);
  }
);


export const sendDispatcherMessage = createAsyncThunk(
  "employees/sendDispatcherMessage",
  async (props) => {
    return TimelineService.sendDispatcherMessage(props);
  }
);
export const setEmployeeMessagesToSeen = createAsyncThunk(
  "employees/setEmployeeMessagesToSeen",
  async (props) => {
    return TimelineService.setEmployeeMessagesToSeen(props);
  }
);

export const sendBroadcastMessage = createAsyncThunk(
  "employees/sendBroadcastMessage",
  async (props) => {
    return TimelineService.sendBroadcastMessage(props);
  }
);

const employeesSlice = createSlice({
  name: "employees",
  initialState,
  reducers: {
    reset: (state) => initialState,
    setTaskList: (state, action) => {
      state.taskList = action.payload;
    },
    setEmployeeSearch: (state, action) => {
      state.employeeSearch = action.payload;
    },
    setEmployeeSearchFilter: (state, action) => {
      state.employeeSearchFilter = action.payload;
    },
    updateEmployeeList: (state, action) => {
      state.employeeList = action.payload;
    },
    setEmployeeFilter: (state, action) => {
      state.employeeFilter = action.payload;
    },
    setEmployeeForm: (state, action) => {
      state.employeeForm = action.payload;
    },
    setSelectedEmployee: (state, action) => {
      state.selectedEmployee = action.payload;
    },
    resetAddEmployeeForm: (state, action) => {
      state.employeeForm = {};
      state.addEmployeeStatus = "idle";
      state.addEmployeeError = null;
      state.addedEmployee = null;
      state.checkUserError = null;
      state.checkUserResult = null;
      state.checkUserStatus = "idle";
    },
    resetEditPasswordForm: (state, action) => {
      state.passwordForm = {};
      state.editPasswordStatus = "idle";
      state.editPasswordError = null;
    },

    resetAssignEmployeesWorkZoneFlags: (state, action) => {
      state.assignEmployeesWorkZoneStatus = "idle";
      state.assignEmployeesWorkZoneError = null;
    },

    resetAllTasksWithFilter: (state) => {
      state.allTaskListWithFilter = [];
      state.allTaskWithFilterStatus = "idle";
      state.allTaskWithFilterError = null;
    },

    resetRemoveWorkzoneEmployeesFlags: (state, action) => {
      state.removeWorkzoneEmployeesStatus = "idle";
      state.removeWorkzoneEmployeesError = null;
    },
    resetDeleteEmployeeFlags: (state, action) => {
      state.deleteEmployeeStatus = "idle";
      state.deleteEmployeeError = null;
    },
    resetUpdateEmployeeStatus: (state) => {
      state.updateEmployeeStatus = "idle";
    },
    resetUpdateEmployeeError: (state) => {
      state.updateEmployeeProfileError = null
    },

    setSelectedEmployeeProfile: (state, action) => {
      state.selectedEmployeeProfile = action.payload;
    },


    resetSendingNotificationFlags: (state) => {
      state.employeeTaskNotificationsStatus = "idle";
      state.employeeTaskNotificationsError = null;
    },

    setEmployeeConversations: (state, action) => {
      state.employeeConversations = action.payload;
    },

    setSelectedForChat: (state, action) => {
      state.selectedForChat = action.payload;
    },

    setEmployeeMessages: (state, action) => {
      state.employeeMessages = action.payload;
    },

    resetNewDispatcherMessageStatus: (state) => {
      state.sendDispatcherMessageStatus = "idle";
      state.sendDispatcherMessageError = null;
    },

    resetSendBroadcastMessageStatus: (state) => {
      state.sendBroadcastMessageStatus = "idle";
      state.sendBroadcastMessageError = null;
    },

    setOpenBroadcastMessages: (state, action) => {
      state.openBroadcastMessages = action.payload;
    },
    setClickedEmployeeId: (state, action) => {
      state.clickedEmployeeId = action.payload;
    },
  },
  extraReducers: {
    [checkUser.pending]: (state, action) => {
      state.checkUserStatus = "loading";
      state.checkUserError = null;
    },
    [checkUser.fulfilled]: (state, action) => {
      state.checkUserStatus = "succeeded";
      state.checkUserError = null;
      state.checkUserResult = action.payload;
    },
    [checkUser.rejected]: (state, action) => {
      state.checkUserStatus = "failed";
      state.checkUserError = action.error.message;
    },
    [getEmployeeList.pending]: (state, action) => {
      state.status = "loading";
    },
    [getEmployeeList.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state.employeeList = action.payload;
    },
    [getEmployeeList.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error.message;
    },
    [addEmployee.pending]: (state, action) => {
      state.addEmployeeStatus = "loading";
    },
    [addEmployee.fulfilled]: (state, action) => {
      state.addEmployeeStatus = "succeeded";
      state.addedEmployee = action.payload;
    },
    [addEmployee.rejected]: (state, action) => {
      state.addEmployeeStatus = "failed";
      state.addEmployeeError = action.error.message;
    },
    [getEmployeeTasks.pending]: (state, action) => {
      state.employeeTaskListStatus = "loading";
    },
    [getEmployeeTasks.fulfilled]: (state, action) => {
      state.employeeTaskListStatus = "succeeded";
      state.employeeTaskList = action.payload;
    },
    [getEmployeeTasks.rejected]: (state, action) => {
      state.employeeTaskListStatus = "failed";
      state.employeeTaskListError = action.error.message;
    },
    [deleteEmployee.pending]: (state, action) => {
      state.deleteEmployeeStatus = "loading";
    },
    [deleteEmployee.fulfilled]: (state, action) => {
      state.deleteEmployeeStatus = "succeeded";
    },
    [deleteEmployee.rejected]: (state, action) => {
      state.deleteEmployeeStatus = "failed";
      state.deleteEmployeeError = action.error.message;
    },
    [updateEmployee.pending]: (state, action) => {
      state.updateEmployeeStatus = "loading";
    },
    [updateEmployee.fulfilled]: (state, action) => {
      state.updateEmployeeStatus = "succeeded";
      state.updatedEmployeeProfile = action.payload;

    },
    [updateEmployee.rejected]: (state, action) => {
      state.updateEmployeeStatus = "failed";
      state.updateEmployeeProfileError = action.error?.message
    },
    [updateOldEmployeeProfile.pending]: (state, action) => {
      return {
        ...state,
        editPasswordStatus: "loading",
      };
    },
    [updateOldEmployeeProfile.fulfilled]: (state, action) => {
      return {
        ...state,
        editPasswordStatus: "succeeded",
      };
    },
    [updateOldEmployeeProfile.rejected]: (state, action) => {
      return {
        ...state,
        editPasswordStatus: "failed",
        editPasswordError: action.error.message,
      };
    },
    [sendEmployeeNotification.pending]: (state, action) => {
      state.employeeTaskNotificationsStatus = "loading";
    },
    [sendEmployeeNotification.fulfilled]: (state, action) => {
      state.employeeTaskNotificationsStatus = "succeeded";
      state.employeeTaskNotifications = action.payload;
    },
    [sendEmployeeNotification.rejected]: (state, action) => {
      state.employeeTaskNotificationsStatus = "failed";
      state.employeeTaskNotificationsError = action.error.message;
    },
    [getEmployeeProductivity.pending]: (state, action) => {
      state.employeeProductivityStatus = "loading";
    },
    [getEmployeeProductivity.fulfilled]: (state, action) => {
      state.employeeProductivityStatus = "succeeded";
      state.employeeProductivity = action.payload;
      state.totalEmpTasks = action.payload.totalTasks
    },
    [getEmployeeProductivity.rejected]: (state, action) => {
      state.employeeProductivityStatus = "failed";
      state.employeeProductivityError = action.error.message;
    },

    [getAllTaskListWithFilter.pending]: (state, action) => {
      state.allTaskWithFilterStatus = "loading";
    },
    [getAllTaskListWithFilter.fulfilled]: (state, action) => {
      state.allTaskWithFilterStatus = "succeeded";
      state.allTaskListWithFilter = action.payload;
    },
    [getAllTaskListWithFilter.rejected]: (state, action) => {
      state.allTaskWithFilterStatus = "failed";
      state.allTaskWithFilterError = action.error.message;
    },

    [assignEmployeesWorkZone.pending]: (state, action) => {
      state.assignEmployeesWorkZoneStatus = "loading";
    },
    [assignEmployeesWorkZone.fulfilled]: (state, action) => {
      state.assignEmployeesWorkZoneStatus = "succeeded";
    },
    [assignEmployeesWorkZone.rejected]: (state, action) => {
      state.assignEmployeesWorkZoneStatus = "failed";
      state.assignEmployeesWorkZoneError = action.error.message;
    },
    [removeWorkzoneEmployees.pending]: (state, action) => {
      state.removeWorkzoneEmployeesStatus = "loading";
    },
    [removeWorkzoneEmployees.fulfilled]: (state, action) => {
      state.removeWorkzoneEmployeesStatus = "succeeded";
    },
    [removeWorkzoneEmployees.rejected]: (state, action) => {
      state.removeWorkzoneEmployeesStatus = "failed";
      state.removeWorkzoneEmployeesError = action.error.message;
    },
    [getAndroidAppVersion.pending]: (state, action) => {
      state.androidAppVersionStatus = "loading";
    },
    [getAndroidAppVersion.fulfilled]: (state, action) => {
      state.androidAppVersionStatus = "succeeded";
      state.androidAppVersion = action.payload;
    },
    [getAndroidAppVersion.rejected]: (state, action) => {
      state.androidAppVersionStatus = "failed";
      state.androidAppVersionError = action.error.message;
    },
    [sendDispatcherMessage.pending]: (state, action) => {
      state.sendDispatcherMessageStatus = "loading";
    },
    [sendDispatcherMessage.fulfilled]: (state, action) => {
      state.sendDispatcherMessageStatus = "succeeded";
      state.newDispatcherMessages = action.payload;
    },
    [sendDispatcherMessage.rejected]: (state, action) => {
      state.sendDispatcherMessageStatus = "failed";
      state.sendDispatcherMessageError = action.error.message;
    },

    [sendBroadcastMessage.pending]: (state, action) => {
      state.sendBroadcastMessageStatus = "loading";
    },
    [sendBroadcastMessage.fulfilled]: (state, action) => {
      state.sendBroadcastMessageStatus = "succeeded";
    },
    [sendBroadcastMessage.rejected]: (state, action) => {
      state.sendBroadcastMessageStatus = "failed";
      state.sendBroadcastMessageError = action.error.message;
    },
  },
});

export const {
  reset,
  setTaskList,
  updateEmployeeList,
  resetAddEmployeeForm,
  resetEditPasswordForm,

  resetAssignEmployeesWorkZoneFlags,
  resetAllTasksWithFilter,
  resetRemoveWorkzoneEmployeesFlags,
  resetDeleteEmployeeFlags,
  resetUpdateEmployeeStatus,
  setSelectedEmployeeProfile,
  resetUpdateEmployeeError,
  resetSendingNotificationFlags,
  setEmployeeConversations,
  setSelectedForChat,
  setEmployeeMessages,
  resetNewDispatcherMessageStatus,
  setOpenBroadcastMessages,
  resetSendBroadcastMessageStatus,
  setClickedEmployeeId

} = employeesSlice.actions;

// check user
export const selectCheckUserStatus = (state) => state.employees.checkUserStatus;
export const selectCheckUserResult = (state) => state.employees.checkUserResult;
export const selectCheckUserError = (state) => state.employees.checkUserError;

export const selectDeleteEmployeeStatus = (state) =>
  state.employees.deleteEmployeeStatus;

export const selectUpdateEmployeeStatus = (state) => state.employees.updateEmployeeStatus;
export const selectUpdateEmployeeError = state => state.employees.updateEmployeeProfileError;
export const selectEditPasswordStatus = state => state.employees.editPasswordStatus
export const selectNewEmployee = (state) => {
  if (
    state.employees.employeeList == undefined ||
    state.employees.employeeList.length == 0
  ) {
    return [];
  }

  let employeeList = [...state.employees.employeeList];
  let newEmployeeList = [];

  employeeList?.forEach((employee) => {
    if (employee.approved == false) {
      newEmployeeList.push(employee);
    }
  });

  return newEmployeeList;
};

export const selectApprovedEmployee = (state) => {
  if (
    state.employees.employeeList == undefined ||
    state.employees.employeeList.length == 0
  ) {
    return [];
  }

  let employeeList = [...state.employees.employeeList];
  let approvedEmployeeList = [];

  employeeList?.forEach((employee) => {
    if (employee.approved == true) {
      approvedEmployeeList.push(employee);
    }
  });

  return approvedEmployeeList;
};

export const selectTimelineApprovedEmployee = (state) => {
  if (
    state.employees.employeeList == undefined ||
    state.employees.employeeList.length == 0 ||
    Object.isObjectEmpty(state.timelineAreas.selectedTimeline)
  ) {
    return [];
  }

  let employeeList = [...state.employees.employeeList];
  let approvedEmployeeList = [];

  employeeList?.forEach((employee) => {
    if (
      employee.approved == true &&
      employee?.workZone?._id === state.timelineAreas.selectedTimeline?._id
    ) {
      approvedEmployeeList.push(employee);
    }
  });

  return approvedEmployeeList;
};

export const selectEmployeeList = (state) => {
  if (
    state.employees.employeeList == undefined ||
    state.employees.employeeList.length == 0
  ) {
    return [];
  }

  let sortedEmployeeList = [...state.employees.employeeList];
  let taskList = state.timelineData.taskList;

  const activeTasks = taskList?.filter((task) => task?.active == true) || [];
  const activeEmployeesIDS = new Set(activeTasks?.map((task) => task?.employeeId).filter(Boolean));
  const activeBreakTasks = state.timelineData.breakTaskList?.filter((task) => task?.active == true) || [];
  const activeBreakTasksIDS = new Set(activeBreakTasks?.map((task) => task?.employeeId).filter(Boolean));

  // check if a timeline zone is selected filter the employees that are in this zone
  if (!Object.isObjectEmpty(state.timelineAreas.selectedTimeline)) {
    const selectedId = state?.timelineAreas?.selectedTimeline?._id;

    sortedEmployeeList = sortedEmployeeList?.filter((employee) => employeeHasSelectedTimeline(employee, selectedId));
  }

  sortedEmployeeList = sortEmployeesByPresenceAndRole(sortedEmployeeList, activeEmployeesIDS, activeBreakTasksIDS);

  let list = sortedEmployeeList?.filter((employee) => (
    filterEmployeeByStatus(employee, state.employees.employeeFilter, activeEmployeesIDS, activeBreakTasksIDS)
  ));
  // search filter
  if (state.employees.employeeSearch !== undefined) {

    // check if passenger filter
    if (state.employees.employeeSearchFilter == "passenger" && state.employees.employeeSearch) {

      // need to use search term to match with a passenger name from task list
      let passengerName = state.employees.employeeSearch;
      let cleanedPassengerName = passengerName.toLowerCase().replace(/\s/g, '');
      let matches = [];

      // for each task
      if (taskList) {
        taskList.forEach((task) => {
          // check if task has passenger information
          if (task && task.passengerInformation && task.passengerInformation.title) {

            // clean passenger name
            let cleanedPassenger = task.passengerInformation.title.toLowerCase().replace(/\s/g, '');

            // if passenger name is found in task, add to matches
            if (cleanedPassenger.includes(cleanedPassengerName)) {
              matches.push(task);
            }

          }
        });
      }

      // get employee ids from list of matched tasks
      let employeeIds = [];
      matches.forEach((task) => {
        if (task.employeeId) {
          employeeIds.push(task.employeeId);
        }
      });

      // filter employee list to only include employees with matching ids
      let newList = [];
      list.forEach((employee) => {
        if (employeeIds.includes(employee.employeeId)) {
          newList.push(employee);
        }
      });

      // set return list to new list
      list = newList;
    }

    // other filters
    else {
      let newList = [];

      list.forEach((employee) => {
        let result;
        if (state.employees.employeeSearchFilter == "name") {
          result = searchEmployeeName(employee, state.employees.employeeSearch)
        }
        else {
          result = searchEmployeeID(employee, state.employees.employeeSearch)
        }
        if (result) { newList.push(employee) }
      })

      list = newList;
    }
  }

  return list;

};

export const selectEmployeeDropdownList = (state) => {
  // check list is not empty
  if (state.employees.employeeList == undefined || state.employees.employeeList.length == 0) {
    return [];
  }

  // map the list to a new array of objects with label and value properties
  let list = state.employees.employeeList.map((employee) => ({
    label: employee.title,
    value: employee.title
  }));

  return list;

}

export const selectEmployeeSearchTerm = (state) => state.employees.employeeSearch;
export const selectEmployeeSearchFilter = (state) => state.employees.employeeSearchFilter;
export const selectAllEmployees = (state) => state.employees.employeeList;
export const selectEmployeeFilter = (state) => state.employees.employeeFilter;
export const selectEmployeeForm = (state) => state.employees.employeeForm;

export const { setEmployeeFilter, setEmployeeForm, setSelectedEmployee, setEmployeeSearch, setEmployeeSearchFilter } =
  employeesSlice.actions;
export const selectEmployeeListStatus = (state) => state.employees.status;

// add employee
export const selectAddEmployeeStatus = (state) =>
  state.employees.addEmployeeStatus;
export const selectAddEmployeeError = (state) =>
  state.employees.addEmployeeError;

// edit password

export const selectEditPasswordError = (state) =>
  state.employees.editPasswordError;

// employee information
export const selectSelectedEmployee = (state) => state.employees.selectedEmployee;
export const selectEmpTotalTasksCount = (state) => state.employees.employeeProductivity?.totalTasks ?? 0;

export const selectEmployeeTaskList = (state) => {
  if (!Array.isFullArray(state.employees.employeeProductivity?.allTasks)) {
    return [];
  }
  const getTaskStatus = (data) => {
    if (data?.active) return "active";
    if (data?.cancelled) return "rejected";
    if (data?.completed) return "completed";
    if (data?.stopped) return "stopped";
    return "assigned";
  };

  let employeeTasks = [...state.employees.employeeProductivity?.allTasks];

  let temp = [];
  employeeTasks?.forEach((task) => {
    let listObject = {
      taskId: task["_id"],
      allocatedTime: task?.allocatedTime && task?.allocatedTime?._seconds
        ? firestoreTimestampToReadable(
          new Date(task?.allocatedTime?._seconds * 1000)
        )
        : "N/A",
      completeTime: task?.completeTime && task?.completeTime?._seconds
        ? firestoreTimestampToReadable(
          new Date(task?.completeTime?._seconds * 1000)
        )
        : "N/A",
      startTime: task?.startTime && task?.startTime?._seconds
        ? firestoreTimestampToReadable(new Date(task?.startTime?._seconds * 1000))
        : "N/A",
      elapsedTime: calculateElapsedTime(task?.startTime, task?.completeTime),
      confirmationPhoto: task?.confirmationPhoto
        ? task?.confirmationPhoto
        : "N/A",
      status: getTaskStatus(task),
      surveyStatus: getSurveyStatus(task.surveyInfo)
    };
    temp.push(listObject);
  });

  return temp;
};


// used in v2 employee-list
export const selectTimelineEmployeeList = (state) => {
  // check array is valid
  if (
    !Array.isArray(state.employees.employeeList) ||
    state.employees.employeeList.length == 0
  ) {
    return [];
  }

  let employeeList = [...state.employees.employeeList];

  // only include online employees
  employeeList = employeeList.filter((employee) => employee.status !== "offline");

  // check if there's a search term - if so, search all online staff (skip zone filtering)
  const hasSearchTerm = state.employees.employeeSearch !== undefined && state.employees.employeeSearch !== "";

  // check if we need to filter by timeline zone (only if no search term)
  if (!hasSearchTerm && !Object.isObjectEmpty(state.timelineAreas.selectedTimeline)) {
    const selectedId = state?.timelineAreas?.selectedTimeline?._id;

    // need to filter by timeline zone before returning
    employeeList = employeeList?.filter((employee) => {
      const workZone = employee?.workZone;

      if (Array.isArray(workZone)) {
        // workZone is an array of zones
        return workZone.some((zone) => zone?.id === selectedId);
      }

      if (workZone && typeof workZone === 'object') {
        // workZone is a single zone object
        return workZone?._id === selectedId || workZone?.id === selectedId;
      }

      return false;
    });
  }

  // search filter
  if (state.employees.employeeSearch !== undefined && state.employees.employeeSearch !== "") {
    let taskList = state.timelineData.taskList;

    // check if passenger filter
    if (state.employees.employeeSearchFilter == "passenger" && state.employees.employeeSearch) {

      // need to use search term to match with a passenger name from task list
      let passengerName = state.employees.employeeSearch;
      let cleanedPassengerName = passengerName.toLowerCase().replace(/\s/g, '');
      let matches = [];

      // for each task
      if (taskList) {
        taskList.forEach((task) => {
          // check if task has passenger information
          if (task && task.passengerInformation && task.passengerInformation.title) {

            // clean passenger name
            let cleanedPassenger = task.passengerInformation.title.toLowerCase().replace(/\s/g, '');

            // if passenger name is found in task, add to matches
            if (cleanedPassenger.includes(cleanedPassengerName)) {
              matches.push(task);
            }

          }
        });
      }

      // get employee ids from list of matched tasks
      let employeeIds = [];
      matches.forEach((task) => {
        if (task.employeeId) {
          employeeIds.push(task.employeeId);
        }
      });

      // filter employee list to only include employees with matching ids
      employeeList = employeeList.filter((employee) => employeeIds.includes(employee.employeeId));
    }

    // other filters (name or ID)
    else {
      employeeList = employeeList.filter((employee) => {
        if (state.employees.employeeSearchFilter == "name") {
          return searchEmployeeName(employee, state.employees.employeeSearch);
        }
        else {
          return searchEmployeeID(employee, state.employees.employeeSearch);
        }
      });
    }
  }

  return employeeList;
}

export const selectEmployeeListByArea = (state) => {
  // check array is valid
  if (
    Array.isArray(state.employees.employeeList) ||
    state.employees.employeeList.length == 0
  ) {
    return [];
  }

  let employeeList = [...state.employees.employeeList];

  // only include online employees
  employeeList = employeeList.filter((employee) => employee.status !== "offline");


  // check if we need to filter by timeline zone (only if no search term)
  if (!Object.isObjectEmpty(state.timelineAreas.selectedTimeline)) {
    const selectedId = state?.timelineAreas?.selectedTimeline?._id;

    // need to filter by timeline zone before returning
    employeeList = employeeList?.filter((employee) => {
      const workZone = employee?.workZone;

      if (Array.isArray(workZone)) {
        // workZone is an array of zones
        return workZone.some((zone) => zone?.id === selectedId);
      }

      if (workZone && typeof workZone === 'object') {
        // workZone is a single zone object
        return workZone?._id === selectedId || workZone?.id === selectedId;
      }

      return false;
    });
  }

  return employeeList;
}
// employee page
export const selectEmployeeAnalytics = (state) => {
  if (
    state.employees.selectedEmployee == undefined ||
    state.employees.selectedEmployee == null
  ) {
    return {};
  }

  if (state.employees.employeeProductivity == undefined
    || state.employees.employeeProductivity == null
    || state.employees.employeeProductivity.completedTasks == undefined
    || state.employees.employeeProductivity.completedTasks == null) {
    return [];
  }

  let timeRequired = 0;
  let totalTasks = 0;
  // check if employee Productivity completedTasks is an array with atleast one element
  if (Array.isFullArray(state.employees.employeeProductivity?.completedTasks)) {
    state.employees.employeeProductivity?.completedTasks?.forEach((task) => {
      if (task?.completed == true && task.startTime) {
        const startDate = new Date(
          task.startTime.seconds * 1000 + task.startTime.nanoseconds / 1000000
        );
        const endDate = new Date(
          task.completeTime.seconds * 1000 +
          task.completeTime.nanoseconds / 1000000
        );
        const timeDifferenceInSeconds = (endDate - startDate) / 1000;
        timeRequired += timeDifferenceInSeconds;
        totalTasks += 1;
      }
    })
  };

  let averageTime = totalTasks > 0 ? timeRequired / totalTasks : 0; // Check if totalTasks > 0 before calculating average

  let averageTimeFormatted = "No Tasks Completed";
  if (totalTasks > 0) {
    const minutes = Math.floor(averageTime / 60);
    const seconds = Math.floor(averageTime % 60);
    averageTimeFormatted = `${minutes} minutes ${seconds} seconds`;
  }

  return {
    averageTime: isNaN(averageTime) ? 0 : averageTimeFormatted,
    totalTasks: totalTasks,
  };
};

// Function to calculate elapsed time
function calculateElapsedTime(startTime, completeTime) {
  if (!startTime || !completeTime) {
    return "N/A";
  }

  const startTimeMillis =
    startTime.seconds * 1000 + startTime.nanoseconds / 1000000; // Convert to milliseconds
  const completeTimeMillis =
    completeTime.seconds * 1000 + completeTime.nanoseconds / 1000000; // Convert to milliseconds

  const elapsedTimeMillis = completeTimeMillis - startTimeMillis;

  const hours = Math.floor(elapsedTimeMillis / (1000 * 60 * 60));
  const minutes = Math.floor(
    (elapsedTimeMillis % (1000 * 60 * 60)) / (1000 * 60)
  );
  const seconds = Math.floor((elapsedTimeMillis % (1000 * 60)) / 1000);

  //   return `${hours}:${minutes}:${seconds}`;
  return `${hours.toString().padStart(2, "0")}H:${minutes
    .toString()
    .padStart(2, "0")}M:${seconds.toString().padStart(2, "0")}S`;
}
export const selectEmployeeRejectedTaskList = (state) => {
  if (!Array.isFullArray(state.employees.employeeProductivity?.rejectedTasks))
    return [];
  let temp = [];
  state.employees.employeeProductivity?.rejectedTasks?.forEach((task) => {
    temp.push({
      taskId: task["_id"],
      allocatedTime: task.allocatedTime
        ? firestoreTimestampToReadable(
          new Date(task.allocatedTime.seconds * 1000)
        )
        : "N/A",
      cancelTime: task?.cancelTime
        ? firestoreTimestampToReadable(new Date(task.cancelTime.seconds * 1000))
        : "N/A",
      rejectReason: task?.rejectReason?.label
        ? task?.rejectReason?.label
        : "N/A",
    });
  });
  return temp;
};
export const selectEmployeeRejectedTaskCSV = (state) => {
  if (!Array.isFullArray(state.employees.employeeProductivity?.rejectedTasks))
    return [];
  let temp = [];
  state.employees.employeeProductivity?.rejectedTasks?.forEach((task) => {
    temp.push({
      taskId: task["_id"],
      allocatedTime: task.allocatedTime
        ? firestoreTimestampToReadable(
          new Date(task.allocatedTime.seconds * 1000)
        )
        : "N/A",
      cancelTime: task?.cancelTime
        ? firestoreTimestampToReadable(new Date(task.cancelTime.seconds * 1000))
        : "N/A",
      rejectReason: task?.rejectReason?.label
        ? task?.rejectReason?.label
        : "N/A",
    });
  });
  return temp;
};
export const selectEmployeeCompletedTaskList = (state) => {
  if (
    state.employees.employeeTaskList == undefined ||
    state.employees.employeeTaskList.length == 0
  ) {
    return [];
  }

  let employeeTasks = [...state.employees.employeeTaskList];
  let temp = [];
  let count = 0;

  employeeTasks?.forEach((task, index) => {
    // Add a condition to include only tasks where completed is false
    if (task.completed) {
      let listObject = {
        index: count,
        taskId: task["_id"],
        allocatedTime: task.allocatedTime
          ? firestoreTimestampToReadable(
            new Date(task.allocatedTime.seconds * 1000)
          )
          : "N/A",
        completeTime: task.completeTime
          ? firestoreTimestampToReadable(
            new Date(task.completeTime.seconds * 1000)
          )
          : "N/A",
        startTime: task.startTime
          ? firestoreTimestampToReadable(
            new Date(task.startTime.seconds * 1000)
          )
          : "N/A",
        elapsedTime: calculateElapsedTime(task.startTime, task.completeTime),
      };
      temp.push(listObject);
      count++;
    }
  });

  return temp;
};
export const selectEmployeeCompletedTaskCSV = (state) => {
  if (
    !Array.isFullArray(state.employees.employeeProductivity?.completedTasks)
  ) {
    return [];
  }

  let employeeTasks = state.employees.employeeProductivity?.completedTasks;
  let temp = [];

  employeeTasks?.forEach((task, index) => {
    // Add a condition to include only tasks where completed is false
    if (task.completed) {
      let listObject = {
        taskId: task["_id"],
        allocatedTime: task.allocatedTime
          ? firestoreTimestampToReadable(
            new Date(task.allocatedTime.seconds * 1000)
          )
          : "N/A",
        completeTime: task.completeTime
          ? firestoreTimestampToReadable(
            new Date(task.completeTime.seconds * 1000)
          )
          : "N/A",
        startTime: task.startTime
          ? firestoreTimestampToReadable(
            new Date(task.startTime.seconds * 1000)
          )
          : "N/A",
        elapsedTime: calculateElapsedTime(task.startTime, task.completeTime),
      };
      temp.push(listObject);
    }
  });

  return temp;
};
export const selectEmployeeProductivity = (state) => {
  if (!state.employees.employeeProductivity) return null;
  const handleCompletionRate = () => {
    if (!state.employees.employeeProductivity?.totalTasks)
      return "No Tasks Completed";
    let res =
      (state.employees.employeeProductivity?.completedTasksCount /
        state.employees.employeeProductivity?.totalTasks) *
      100;
    if (res.toString().includes(".")) return `${res.toFixed(2)}%`;
    else return `${res}%`;
  };

  return {
    ...state.employees.employeeProductivity,
    completionRate: handleCompletionRate(),
  };
};

// all tasks with filter CSV
export const selectAllTasksWithFilterCSV = (state) => {
  if (!Array.isFullArray(state.employees.allTaskListWithFilter)) {
    return [];
  }

  const getTaskStatus = (data) => {
    if (data?.active) return "active";
    if (data?.cancelled) return "rejected";
    if (data?.completed) return "completed";
    if (data?.stopped) return "stopped";
    return "assigned";
  };

  const getDetailsDate = (date) => {
    // Create a new Date object from the input string
    const dateObj = new Date(date);
    // Format the date object as "M/d/yyyy"
    const outputDate = `${dateObj.getMonth() + 1
      }/${dateObj.getDate()}/${dateObj.getFullYear()}`;
    return outputDate;
  };

  const getDetailsTime = (date) => {
    // Create a new Date object from the input string
    const dateObj = new Date(date);
    const options = {
      hour: "2-digit",
      minute: "2-digit",
    };
    // convert dateString to the user current timeZone and take the time of it
    const formattedTime = dateObj.toLocaleString("en-US", options);
    return formattedTime;
  };


  const getEmployeeData = (id) => {
    let filteredEmployee = state.employees.employeeList?.filter(
      (row) => row?.employeeId == id
    );
    if (Array.isFullArray(filteredEmployee)) return filteredEmployee[0];
    return null;
  };

  let csvData = [];
  let counter = 1

  state.employees.allTaskListWithFilter?.forEach((task, index) => {

    let listObject = {
      index: `${counter++}`,
      serviceStatus: getTaskStatus(task),
      requestType: task?.notPlanned ? "Not Planned" : "Planned",
      flightDate: getDetailsDate(task?.flightInformation?.flightTime),
      flightNo: task?.flightInformation?.flightNumber,
      flightTime: getDetailsTime(task?.flightInformation?.flightTime),
      origin: task?.flightInformation?.departureAirport,
      destination: task?.flightInformation?.arrivalAirport,
      seatNo: task?.flightInformation?.seatNumber?.trim() ?? "N/A",
      assignedTime: task.assignedTime || "N/A",
      acknowledgedTime: task.acknowledged ? getDetailsTime(new Date(task.acknowledgedTime.seconds * 1000)) : "N/A",
      startTime:
        task?.startTime && Object.isObjectEmpty(task?.rejectReason)
          ? getDetailsTime(new Date(task.startTime.seconds * 1000))
          : "N/A",
      completeTime:
        task?.completeTime && Object.isObjectEmpty(task?.rejectReason)
          ? getDetailsTime(new Date(task.completeTime.seconds * 1000))
          : "N/A",
      serviceDuration:
        task?.startTime &&
          task?.completeTime &&
          Object.isObjectEmpty(task?.rejectReason)
          ? getDurationInMinutes(
            new Date(task.startTime.seconds * 1000),
            new Date(task.completeTime.seconds * 1000)
          )
          : "N/A",

      prn: task?.employeeId,
      workerName: getEmployeeData(task?.employeeId)?.title ?? "N/A",
      arrDep: "A",   //Need to update this value depend on task airport!
      rejectReason: task?.rejectReason?.label
        ? task?.rejectReason?.label
        : "N/A",
    };
    csvData.push(listObject);
  });
  return csvData;
};
export const selectAssignEmployeesWorkZoneStatus = (state) => state.employees.assignEmployeesWorkZoneStatus;
export const selectAllTaskWithFilterStatus = (state) => state.employees.allTaskWithFilterStatus;
export const selectRemoveWorkzoneEmployeesStatus = (state) => state.employees.removeWorkzoneEmployeesStatus;
export const selectDeleteEmployeeError = (state) => state.employees.deleteEmployeeError;
// get all employees without any filter applied 
export const selectEmployeeQRScannerList = (state) => {
  if (!Array.isFullArray(state.employees.employeeList)) return []
  return state.employees.employeeList
};
export const selectTimeLineAnalytics = (state) => {
  let tempTaskList = state.timelineData.taskList
  if (!Array.isFullArray(tempTaskList)) return null
  // remove employee break tasks from the tasks array
  tempTaskList = tempTaskList?.filter((task) => task?.isBreakTask !== true && task?.employeeId !== null)
  return {
    totalTasks: tempTaskList?.length ?? 0,
    completedTasks: tempTaskList?.filter((task) => task?.completed == true)?.length ?? 0,
    assignedTasks: tempTaskList?.filter((task) => task?.completed !== true && task?.cancelled !== true)?.length ?? 0,
    rejectedTasks: tempTaskList?.filter((task) => task?.cancelled == true)?.length ?? 0,
  }
}
export const selectAndroidAppVersion = (state) => state.employees.androidAppVersion;

export const selectSelectedEmployeeProfile = (state) => state.employees.selectedEmployeeProfile;
export const selectUpdatedEmployeeProfile = (state) => state.employees.updatedEmployeeProfile;
export const selectSendNotificationStatus = (state) => state.employees.employeeTaskNotificationsStatus;
export const selectEmployeeConversations = (state) => state.employees.employeeConversations;
export const selectSelectedForChat = (state) => state.employees.selectedForChat;
export const selectNewDispatcherMessage = (state) => state.employees.newDispatcherMessages;
export const selectSendDispatcherMessageStatus = (state) => state.employees.sendDispatcherMessageStatus;

export const selectEmployeeMessages = (state) => {
  const processedMessages = [];
  let lastDate = '';
  let messages = Array.isFullArray(state.employees.employeeMessages) ? [...state.employees.employeeMessages] : [];

  [...messages].reverse().forEach((msg) => {

    const msgDate = msg?.sentAt?.seconds ? new Date(msg?.sentAt?.seconds * 1000) : new Date(msg?.sentAt);
    const currentDate = msgDate.toDateString();

    if (currentDate !== lastDate) {
      processedMessages.push({
        type: 'header',
        date: currentDate,
        id: `header-${currentDate}`
      });
      lastDate = currentDate;
    }

    processedMessages.push(msg);
  });
  return processedMessages;
};

export const selectOpenBroadcastMessages = (state) => state.employees.openBroadcastMessages;
export const selectSendBroadcastMessageStatus = (state) => state.employees.sendBroadcastMessageStatus;
export const selectClickedEmployeeId = state => state.employees.clickedEmployeeId
export default employeesSlice.reducer;
